export default function WorkExperience() {
    return <div>
        <h2 className={"jobPositionHeader"}>Modus Operandi</h2>
        <h3>Software Engineering Intern</h3>
        <p>🗓️ June 2024 - August 2024</p>
        <p>📍 Melbourne, FL</p>
        <ul>
            <li>Worked on tasks across a variety of topics, including document ingestion, large language model
                integration, and REST API creation
            </li>
            <li>Learned to use Docker to create containerized services accessible via HTTP requests</li>
            <li>Worked to create deliverables in a timely manner while also maintaining a high level of code
                quality, including having unit tests with high code coverage
            </li>
        </ul>
        <h2 className={"jobPositionHeader"} id={'mitraLabWorkExperience'}>BiCLab, Florida Institute of Technology</h2>
        <h3>On-Campus Lab Assistant</h3>
        <p>🗓️ July 2023 - December 2024</p>
        <p>📍 Melbourne, FL</p>
        <ul>
            <li>Working with Geant4, a particle simulation program, to create a basic SPECT scan simulation</li>
            <li>Made a neural network that uses data generated from the aforementioned SPECT simulation to
                reconstruct the location of a gamma point source in 3D space
            </li>
            <li>Currently making an auto-encoder decoder CNN for the purposes of reconstruction 3D SPECT sinogram
                data.
            </li>
            <li>Actively maintaining the lab, including the three lab computers, which all run Ubuntu</li>
        </ul>
        <h2 className={"jobPositionHeader"}>Independent Private Tutoring</h2>
        <p>🗓️ On and off since 2021</p>
        <ul>
            <li>Tutored in a variety of subjects, including algebra geometry, precalculus, calculus, chemistry, and
            computer science topics</li>
            <li>Students I tutored almost always saw a gradual increase in grades for their tutored subject</li>
            <ul><li>I have been told I have am great to work with and have great technical communication skills, able
            to convey complex and technical concept in a digestible manner</li></ul>
        </ul>
        <h2 className={"jobPositionHeader"}>Barnes & Noble</h2>
        <h3>Bookseller</h3>
        <p>🗓️ November 2021 - June 2022</p>
        <p>📍 Poughkeepsie, NY</p>
        <ul>
            <li>Provided excellent customer service including helping customers locate or order books and completing
                customer transactions
            </li>
            <li>Maintained store by occasionally shelving products, creating displays, and cleaning when necessary</li>
            <li>Collaborated with a team of booksellers to create a positive customer experience</li>
        </ul>
    </div>
}